import initialState from "./initialState";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

function recentsReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.RECENTS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingRecents: true, recents: [] };
        case getNamedAction(ACTION_NAMES.RECENTS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingRecents: false, recents: action.data };
        case getNamedAction(ACTION_NAMES.RECENTS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingRecents: false, recents: [] };

        case getNamedAction(ACTION_NAMES.RECENTS, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isAddingRecent: true };
        case getNamedAction(ACTION_NAMES.RECENTS, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isAddingRecent: false };
        case getNamedAction(ACTION_NAMES.RECENTS, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isAddingRecent: false };

        default:
            return state;
    }
}


export default recentsReducer;
